var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.776,
    height: 44.305,
    viewBox: "0 0 42.776 44.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(-765 -1732.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8521",
    "data-name": "Path 8521",
    d: "M407.359,219.4a18.79,18.79,0,0,0,3.88-11.4v4.583a18.787,18.787,0,0,1-3.819,11.32v-4.446Zm0,0",
    transform: "translate(396.537 1544.25)",
    fill: "#ce893d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8522",
    "data-name": "Path 8522",
    d: "M371.459,327.495v4.446a20.223,20.223,0,0,1-3.819,3.888v-4.515l-.038-.046a20.242,20.242,0,0,0,3.8-3.827Zm0,0",
    transform: "translate(432.498 1436.213)",
    fill: "#e6a71e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8523",
    "data-name": "Path 8523",
    d: "M21.388,0C33.2,0,42.776,8.891,42.776,19.86a18.789,18.789,0,0,1-3.88,11.4,20.245,20.245,0,0,1-3.8,3.827,20.65,20.65,0,0,1-3.781,2.36,22.25,22.25,0,0,1-4.583,1.643,23.137,23.137,0,0,1-10.694,0,22.251,22.251,0,0,1-4.583-1.643,20.661,20.661,0,0,1-3.781-2.36,20.245,20.245,0,0,1-3.8-3.827A18.79,18.79,0,0,1,0,19.86C0,8.891,9.579,0,21.388,0Zm0,0",
    transform: "translate(765 1732.39)",
    fill: "#ffcb5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8524",
    "data-name": "Path 8524",
    d: "M331.819,367.565v4.514a20.725,20.725,0,0,1-3.812,2.376L328,374.44v-4.56a20.647,20.647,0,0,0,3.781-2.36Zm0,0",
    transform: "translate(468.318 1399.962)",
    fill: "#ce893d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8525",
    "data-name": "Path 8525",
    d: "M284.583,396.8l.008.015a22.038,22.038,0,0,1-4.56,1.642l-.031-.13v-4.446a22.249,22.249,0,0,0,4.583-1.643Zm0,0",
    transform: "translate(511.734 1377.603)",
    fill: "#e6a71e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8526",
    "data-name": "Path 8526",
    d: "M229.377,414.016a23.031,23.031,0,0,1-5.378.634v-4.583a22.783,22.783,0,0,0,5.347-.626v4.445Zm0,0",
    transform: "translate(562.389 1362.043)",
    fill: "#ce893d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8527",
    "data-name": "Path 8527",
    d: "M173.057,410.068v4.583a23.034,23.034,0,0,1-5.378-.634l.031-.13v-4.446a22.787,22.787,0,0,0,5.347.627Zm0,0",
    transform: "translate(613.33 1362.043)",
    fill: "#e6a71e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8528",
    "data-name": "Path 8528",
    d: "M124.513,393.881v4.446l-.031.13a22.036,22.036,0,0,1-4.56-1.642l.007-.015v-4.56a22.249,22.249,0,0,0,4.584,1.641Zm0,0",
    transform: "translate(656.529 1377.604)",
    fill: "#ce893d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8529",
    "data-name": "Path 8529",
    d: "M80.038,367.52a20.664,20.664,0,0,0,3.781,2.36v4.56l-.007.015A21.142,21.142,0,0,1,80,372.08v-4.515Zm0,0",
    transform: "translate(692.639 1399.962)",
    fill: "#e6a71e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8530",
    "data-name": "Path 8530",
    d: "M40.061,327.441a20.246,20.246,0,0,0,3.8,3.827l-.038.046v4.515A20.22,20.22,0,0,1,40,331.94v-4.446Zm0,0",
    transform: "translate(728.82 1436.214)",
    fill: "#ce893d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8531",
    "data-name": "Path 8531",
    d: "M0,208a18.79,18.79,0,0,0,3.88,11.4l-.061.053V223.9A18.787,18.787,0,0,1,0,212.583Zm0,0",
    transform: "translate(765 1544.25)",
    fill: "#e6a71e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8532",
    "data-name": "Path 8532",
    d: "M81.61,63.277C81.61,54.84,74.086,48,64.8,48S48,54.84,48,63.277s7.524,15.277,16.8,15.277S81.61,71.715,81.61,63.277Zm0,0",
    transform: "translate(721.584 1688.973)",
    fill: "#e6a71e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    transform: "translate(771.875 1739.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8533",
    "data-name": "Path 8533",
    d: "M324.052,264.132l-1.044-1.114a11.616,11.616,0,0,0,2.241-2.866l1.338.735a13.064,13.064,0,0,1-2.534,3.245Zm0,0",
    transform: "translate(-299.041 -242.187)",
    fill: "#ffcb5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8534",
    "data-name": "Path 8534",
    d: "M86.513,97.971c-8,0-14.513-5.825-14.513-12.986S78.51,72,86.513,72s14.513,5.825,14.513,12.986H99.5c0-6.318-5.825-11.458-12.986-11.458s-12.986,5.14-12.986,11.458,5.825,11.458,12.986,11.458a14.141,14.141,0,0,0,7.247-1.957l.783,1.313a15.674,15.674,0,0,1-8.031,2.171Zm0,0",
    transform: "translate(-72 -72)",
    fill: "#ffcb5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.c9dc95f487b0dec46dcd69310ac11b58.svg";
export { ForwardRef as ReactComponent };